<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="primaryNodeOptions"
          :load-options="loadPrimaryNodeOptions"
          :disable-branch-nodes="true"
          :disabled="
            !hasPermissionToCreateExport ||
              opticalEquipmentFieldsDisabled ||
              !userHasPermissionToList('technical_local')
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "PrimaryNodeFiberDistributionPlanReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "PrimaryNode",
          key: "primary_node",
          type: "text",
          value: undefined
        }
      ],

      primaryNodeOptions: null,

      historyFilter: "primary_node_fiber_distribution_plan"
    };
  },

  computed: {
    opticalEquipmentFieldsDisabled() {
      return this.selectedWorkspace === undefined;
    },
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: {
            uuid: this.reportParameters[0].value,
            object_type: "technical_local"
          }
        }
      };
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.primaryNodeOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    loadPrimaryNodeOptions({ callback }) {
      if (this.selectedWorkspace) {
        this.getWorkspaceTechnicalSitesWithLocals().then(
          technicalSitesWithLocals => {
            this.primaryNodeOptions = this.getWorkspacePrimaryNodesOptions(
              technicalSitesWithLocals
            );
            callback();
          }
        );
      } else {
        callback();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/PNFiberDistributionPlan.vue